module.exports = __webpack_public_path__ + "static/media/randomIcon.d7acbf4d.svg";